import {Axios} from 'services/axios';

export const dashboardApi = {
  fetchOverview: async () => {
    try {
      const response = await Axios.fetch('/dashboard/overview');

      if (!response || !response.data) {
        throw new Error('Invalid response structure from server');
      }

      return response.data.data || response.data || {};
    } catch (error) {
      console.error('Error fetching dashboard overview:', error);

      let errorMessage = 'Failed to fetch dashboard overview';

      if (error.response) {
        errorMessage =
          error.response.data?.message ||
          `Server error: ${error.response.status}`;
      } else if (error.request) {
        errorMessage = 'Network error: Unable to reach server';
      } else {
        errorMessage = error.message || errorMessage;
      }

      throw new Error(errorMessage);
    }
  },
};
